import { Dispatch } from 'redux';
import {
  getAccountInfo as _getAccount,
  updateAccountInfo as _updateAccount,
} from 'src/services/account';
import { ThunkActionCreator } from 'src/store/types';
import { createRequestThunk } from 'src/store/store.helpers';
import {
  accountRequestStarted,
  accountRequestFail,
  accountRequestSuccess,
  updateAccountActions,
} from './account.actions';

import { authenticatedUser } from 'src/utilities/storage';
import { Account } from 'src/types/Account';

/**
 * Async
 */
export const requestAccount: ThunkActionCreator<Promise<Account>, any> =
  (id?: string) => (dispatch: Dispatch<any>, _getStore: any) => {
    dispatch(accountRequestStarted());
    const accountId = id ? id : authenticatedUser.accountId.get();
    return _getAccount(accountId)
      .then((response: any) => {
        dispatch(accountRequestSuccess(response));
        return response;
      })
      .catch((err: any) => {
        dispatch(accountRequestFail(err));
        return err;
      });
  };


export const updateAccount = createRequestThunk(
  updateAccountActions,
  ({ ...data }) => _updateAccount(data)
);

export const upsertAccount = (data: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch(accountRequestSuccess(data));
};
